module.exports = __webpack_public_path__ + "static/img/zcw.72a954fe.png";